import { render, staticRenderFns } from "./MessengerContent.vue?vue&type=template&id=2e949776&scoped=true"
import script from "./MessengerContent.vue?vue&type=script&lang=js"
export * from "./MessengerContent.vue?vue&type=script&lang=js"
import style0 from "./MessengerContent.vue?vue&type=style&index=0&id=2e949776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e949776",
  null
  
)

export default component.exports